import script from "./houseCart.vue?vue&type=script&setup=true&lang=js"
export * from "./houseCart.vue?vue&type=script&setup=true&lang=js"

import "./houseCart.vue?vue&type=style&index=0&id=0c8c8e7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c8c8e7e"]])

export default __exports__